// Datas no fuso do negócio (America/Maceio). O dispositivo pode estar em outro
// fuso e new Date().toISOString() vira o dia às 21h locais (UTC-3).

// Hoje em YYYY-MM-DD no fuso de Maceió (en-CA produz o formato ISO).
//
// ── COM CACHE, e ele não é otimização prematura: é conserto de regressão medida ────────────
// `toLocaleDateString` com `timeZone` monta um `Intl.DateTimeFormat` a cada chamada, e isso
// custa ~200µs — três ordens de grandeza acima de uma conta de data. Enquanto esta função era
// chamada punhados de vezes por tela, não importava. Em 2026-08-28 ela virou o DEFAULT de
// parâmetro de `diasSemDiario`, `diasPausada` e `ondeParou`: passou a rodar
// uma vez por OS na varredura de contagem (5000) e três vezes por linha renderizada (100).
// Um cético mediu: `diasSemDiario` x5000 foi de 13,7ms para 1030ms. A tela inteira travava
// meio segundo a cada render, por causa de um default de parâmetro.
//
// O cache dura 60s. NÃO é "para sempre": uma aba aberta atravessando a meia-noite precisa ver
// o dia virar — é a diferença entre "atrasada" e "vence hoje", e ela vira sozinha às 00:00. Um
// minuto de defasagem na virada é invisível; um dia inteiro não seria.
const _JANELA_CACHE = 60000;
let _hojeCache = { ate: 0, valor: '' };
export function hojeMaceio() {
  const agora = Date.now();
  // O RELOGIO PODE ANDAR PARA TRAS, e o cache tem de perceber.
  //
  // `agora >= ate` sozinho basta para o tempo correndo para a frente. Mas o teste fixa o relogio
  // — e frequentemente no PASSADO —, e ai `agora` fica MENOR que o `ate` gravado com a hora real:
  // o cache nunca expira e a funcao devolve a data de verdade enquanto o teste acredita estar em
  // outro dia. Medido em 2026-08-29, quando fixei um teste num sabado e ele continuou vendo o
  // sabado. Cache que nao percebe o relogio voltando e cache que mente em silencio.
  const voltou = agora < _hojeCache.ate - _JANELA_CACHE;
  if (agora >= _hojeCache.ate || voltou) {
    _hojeCache = {
      ate: agora + _JANELA_CACHE,
      valor: new Date().toLocaleDateString('en-CA', { timeZone: 'America/Maceio' }),
    };
  }
  return _hojeCache.valor;
}

// Objeto Date ao MEIO-DIA local representando a data CIVIL de Maceió. Usado como ÂNCORA
// do calendário do app de campo, para que o "hoje"/semana/mês fiquem alinhados ao dia de
// negócio (e ao cálculo de atraso, que usa hojeMaceio) mesmo que o dispositivo esteja em
// outro fuso. O meio-dia evita off-by-one por rollover de meia-noite/DST ao formatar/somar.
export function hojeMaceioDate() {
  const [y, m, d] = hojeMaceio().split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

/**
 * A DATA CIVIL DE MACEIÓ de um carimbo — `2026-08-25T00:30:00Z` → `'2026-08-24'`.
 *
 * ── POR QUE `slice(0, 10)` NÃO SERVE ───────────────────────────────────────────────────────
 * Todo carimbo desta base é gravado em UTC (`datetime.now(timezone.utc).isoformat()`), e Maceió
 * é UTC−3. Cortar a string pega a data **UTC**: uma OS iniciada às 21h30 de 24/08 grava
 * `2026-08-25T00:30Z` e o corte devolve `'2026-08-25'`. O modal chegava a mostrar as duas
 * versões, uma embaixo da outra — "Iniciada em 25/08/2026" logo acima de "24/08/2026, 21:30:00",
 * porque o segundo bloco usa `toLocaleString`, que converte.
 *
 * Em `diasPausada` era pior que data errada: ela comparava `pausado_em` cortado em UTC contra
 * `hojeMaceio()`, dava `-1` na noite da pausa, a guarda `d >= 0` reprovava e a frase
 * "Pausada há Nd" **sumia** — e do dia seguinte em diante contava um dia a menos.
 *
 * ── E POR QUE NÃO CONVERTER DENTRO DE `formatDate` ─────────────────────────────────────────
 * Porque `formatDate` também recebe data de NEGÓCIO (`date`, `data_fim_prevista`), que já é
 * `AAAA-MM-DD` sem hora e não deve ser convertida — converter ali moveria o prazo de toda OS.
 * A conversão é do chamador que sabe estar segurando um INSTANTE, e é esta função.
 *
 * Data pura (`AAAA-MM-DD`, sem `T`) passa intacta: ela já é civil, e reinterpretá-la como
 * meia-noite UTC a jogaria um dia para trás — o defeito ao contrário.
 */
// UM formatter, montado uma vez. `toLocaleDateString` com `timeZone` monta um
// `Intl.DateTimeFormat` A CADA CHAMADA, e a regra está escrita 50 linhas acima, em `hojeMaceio`
// — que ganhou cache exatamente por isso. Eu escrevi `diaCivilMaceio` ignorando a própria regra
// do arquivo, e um cético mediu: 124,66 µs por chamada contra 2,35 µs com o formatter reusado.
//
// O volume é 1 chamada por linha da lista (o tique de início real da barra) mais 1 por OS
// pausada: 100 linhas ≈ 12,5 ms por render, contra 0,2 ms assim. Não é o meio segundo do
// incidente anterior, mas é 50× no mesmo lugar em que este repo já se queimou.
//
// CACHE NÃO SERVE AQUI (e é a diferença para `hojeMaceio`): o argumento muda a cada chamada. O
// que dá para reusar é o FORMATTER, que é a parte cara.
const _fmtMaceio = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Maceio' });

export function diaCivilMaceio(carimbo) {
  const s = String(carimbo || '');
  if (!s) return '';
  if (!s.includes('T')) return s.slice(0, 10);      // já é data civil
  const t = new Date(s);
  if (Number.isNaN(t.getTime())) return s.slice(0, 10);
  return _fmtMaceio.format(t);
}

// Fim efetivo de uma demanda (modelo multi-dia): data_fim_prevista quando
// válida (>= date), senão a própria date. Strings YYYY-MM-DD comparáveis.
export function fimEfetivo(demanda) {
  const date = demanda?.date;
  const fim = demanda?.data_fim_prevista;
  return fim && date && fim >= date ? fim : date;
}

/**
 * O DIA DE QUE O CAMPO FALA, PRESO AO INTERVALO DA OS — espelho de
 * `backend/routes/mobile_demandas_ausencia.py::dia_do_campo`.
 *
 * OS atrasada é iniciada DEPOIS do fim previsto, e OS adiantada antes do início: sem a prisão,
 * nenhuma ida seria "a de hoje" e as telas voltariam a listar a UNIÃO — que desde 2026-09-22
 * guarda de propósito quem está escalado para OUTRO dia.
 *
 * MOROU EM `components/mobile/IniciarDemandaModal` ATÉ 2026-09-23, e veio para cá pelo MESMO
 * motivo de `estaAtrasada`, logo abaixo: quem precisa dela não é só aquele modal. Quando
 * `ReportarAusenciaEquipe` passou a importá-la de lá, SEIS suítes que fazem
 * `jest.mock('./IniciarDemandaModal')` ficaram com `diaDaIda === undefined` — e uma delas
 * (`MobileColaboradorPage.apoio.test.js`) quebrou em `TypeError` no meio de seis testes que não
 * têm nada a ver com o assunto. Régua de data não pode morar dentro de um componente.
 */
export const diaDaIda = (demanda, hoje) => {
  const ini = String(demanda?.date || '').slice(0, 10);
  const h = String(hoje || '').slice(0, 10);
  if (!ini) return h;
  const fim = String(fimEfetivo(demanda) || ini).slice(0, 10) || ini;
  return h < ini ? ini : (h > fim ? fim : h);
};

/**
 * OS ABERTAS COM PRAZO CORRENDO — espelho de `STATUS_ABERTOS_COM_PRAZO`
 * (backend/services/demanda.py:121).
 */
export const STATUS_ABERTOS_COM_PRAZO = ['pending', 'overdue', 'in_progress', 'paused'];

/**
 * AS QUE PODEM ESTAR ATRASADAS — espelho de `STATUS_QUE_ATRASAM` (backend/services/demanda.py): as abertas com prazo
 * MENOS a pausada. Dono, 2026-11-03: *"a ideia de pausar é justamente porque foi paralisado [...] deveria sair de
 * atrasado"* (revoga a regra de 2026-08, "Pausada · atrasada").
 */
export const STATUS_QUE_ATRASAM = ['pending', 'overdue', 'in_progress'];

/**
 * A OS ESTÁ ATRASADA AGORA? — UMA pergunta, UMA resposta, nos DOIS aplicativos.
 *
 * Ela nasceu em `pages/WeeklyView.helpers` e ficou fora do alcance do app de campo, que importa
 * só deste módulo. Resultado: `components/mobile/DemandaCard` e `pages/MobileColaboradorPage`
 * continuaram com a conta à mão, sem `paused` — a OS pausada e vencida aparecia ao colaborador
 * como "Pausada" enquanto o gestor já a via vermelha. Aqui embaixo, os dois lados alcançam.
 * `WeeklyView.helpers` reexporta, para não quebrar quem já importava de lá.
 */
export const estaAtrasada = (d, hoje) => (
  !!d
  && STATUS_QUE_ATRASAM.includes(d.status)
  && !!d.date
  && fimEfetivo(d) < hoje
);
